const UnstarIcon = ({ isStarred }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="23" height="23" rx="5.5" fill="#F2F3F5" />
      <rect x="0.5" y="0.5" width="23" height="23" rx="5.5" stroke="#D7D7D8" />
      <path
        d="M15.5501 13.3914C15.3947 13.5419 15.3233 13.7597 15.3587 13.9733L15.892 16.9249C15.937 17.1751 15.8314 17.4282 15.6221 17.5728C15.4169 17.7228 15.1439 17.7408 14.9202 17.6208L12.2631 16.235C12.1707 16.1858 12.0681 16.1594 11.9631 16.1564H11.8006C11.7442 16.1648 11.689 16.1828 11.6386 16.2104L8.98094 17.6028C8.84955 17.6688 8.70077 17.6922 8.55499 17.6688C8.19984 17.6016 7.96287 17.2633 8.02106 16.9063L8.55499 13.9547C8.59039 13.7393 8.519 13.5203 8.36362 13.3674L6.1973 11.2676C6.01612 11.0919 5.95313 10.8279 6.03592 10.5897C6.11631 10.3522 6.32148 10.1788 6.56925 10.1398L9.55086 9.70725C9.77763 9.68385 9.97681 9.54587 10.0788 9.3419L11.3926 6.64825C11.4238 6.58826 11.464 6.53306 11.5126 6.48627L11.5666 6.44427C11.5948 6.41308 11.6272 6.38728 11.6632 6.36628L11.7286 6.34229L11.8306 6.30029H12.0831C12.3087 6.32369 12.5073 6.45867 12.6111 6.66025L13.9423 9.3419C14.0383 9.53807 14.2249 9.67425 14.4402 9.70725L17.4218 10.1398C17.6738 10.1758 17.8844 10.3498 17.9678 10.5897C18.0464 10.8303 17.9786 11.0943 17.7938 11.2676L15.5501 13.3914Z"
        fill="#1660CD"
      />
    </svg>
  );
};

export default UnstarIcon;
